import { useEffect, useState } from "react";
import { db } from "./firebase";
import { collection, getDocs } from "firebase/firestore";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";
import PageLayout from "./components/PageLayout";
import Username from "./components/Username";
import { isProUser } from "./utils/entitlements";

function ForSale() {
  const [carsForSale, setCarsForSale] = useState([]);

  useEffect(() => {
    const loadForSaleCars = async () => {
      const snapshot = await getDocs(collection(db, "profiles"));
      const list = [];

      snapshot.forEach((doc) => {
        const profile = doc.data();

        if (profile.garageCars && profile.garageCars.length > 0) {
          profile.garageCars.forEach((car) => {
            if (car.status === "For Sale") {
              list.push({
                ...car,
                ownerUsername: profile.username,
                ownerIsPro: isProUser(profile),
              });
            }
          });
        }
      });

      setCarsForSale(list);
    };

    loadForSaleCars();
  }, []);

  return (
    <>
      <Navbar />

      <PageLayout maxWidth="1100px">
        <h1>For Sale</h1>

        {carsForSale.length === 0 && (
          <p style={emptyStyle}>
            No builds are listed for sale yet.
          </p>
        )}

        <div style={gridStyle}>
          {carsForSale.map((car) => (
            <Link
              key={`${car.ownerUsername}-${car.id}`}
              to={`/user/${car.ownerUsername}/car/${car.id}`}
              style={cardLinkStyle}
            >
              <div style={cardStyle}>
                {car.images && car.images.length > 0 ? (
                  <img
                    src={car.images[0]}
                    alt={car.name}
                    style={carImageStyle}
                  />
                ) : (
                  <div style={placeholderImageStyle}>
                    No Photo
                  </div>
                )}

                <div style={cardContentStyle}>
                  <span style={saleBadgeStyle}>
                    For Sale
                  </span>

                  <h2>{car.name}</h2>

                  <p style={usernameStyle}><Username username={car.ownerUsername} isPro={car.ownerIsPro} /></p>

                  {car.saleInfo?.price && (
                    <p style={saleDetailStyle}>
                      Price: {car.saleInfo.price}
                    </p>
                  )}

                  {car.saleInfo?.mileage && (
                    <p style={saleDetailStyle}>
                      Mileage: {car.saleInfo.mileage}
                    </p>
                  )}

                  <p style={detailsStyle}>
                    {car.details}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </PageLayout>
    </>
  );
}

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
  gap: "18px",
  marginTop: "24px",
};

const cardLinkStyle = {
  textDecoration: "none",
  color: "white",
};

const cardStyle = {
  backgroundColor: "#181818",
  border: "1px solid #242424",
  borderRadius: "18px",
  overflow: "hidden",
};

const carImageStyle = {
  width: "100%",
  height: "190px",
  objectFit: "cover",
  display: "block",
};

const placeholderImageStyle = {
  height: "190px",
  backgroundColor: "#222",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "#777",
};

const cardContentStyle = {
  padding: "18px",
};

const saleBadgeStyle = {
  backgroundColor: "#e10600",
  color: "white",
  padding: "8px 14px",
  borderRadius: "999px",
  fontSize: "11px",
  letterSpacing: "0.5px",
  textTransform: "uppercase",
  fontWeight: "bold",
  display: "inline-block",
};

const usernameStyle = {
  opacity: 0.7,
};

const detailsStyle = {
  opacity: 0.85,
  lineHeight: "1.6",
};

const emptyStyle = {
  opacity: 0.7,
  marginTop: "30px",
};

const saleDetailStyle = {
  opacity: 0.9,
  fontWeight: "bold",
};

export default ForSale;
